import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import PublicHeader from '../PublicHeader';

export default function PublicLayout({ setIsLoginOpen, setIsSignupOpen }) {
  const location = useLocation();
  const [invalidState, setInvalidState] = useState(false);
  const userRole = localStorage.getItem('userRole');
  const currentPath = location.pathname;

  // ✅ These are all routes where PublicHeader should be shown
  const publicRoutes = ['/', '/courses', '/webinars', '/certifications', '/aboutmentor'];

  // ✅ Fallback for invalid localStorage state
  useEffect(() => {
    if (
      currentPath === '/' &&
      userRole &&
      !['student', 'mentor', 'admin'].includes(userRole)
    ) {
      setInvalidState(true);
    }
  }, [currentPath, userRole]);

  const handleReset = () => {
    localStorage.clear();
    window.location.reload();
  };

  return (
    <>
      {invalidState && (
        <div style={{ background: '#f44336', color: 'white', padding: '10px', textAlign: 'center' }}>
          Having trouble loading the page?&nbsp;
          <button
            onClick={handleReset}
            style={{
              background: '#ffffff',
              color: '#f44336',
              border: 'none',
              padding: '5px 10px',
              borderRadius: '5px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
          >
            Click here to reset
          </button>
        </div>
      )}

      {(publicRoutes.includes(currentPath) || !userRole) && (
        <PublicHeader
          setIsLoginOpen={setIsLoginOpen}
          setIsSignupOpen={setIsSignupOpen}
        />
      )}

      <Outlet />
    </>
  );
}
